export const GET_QUESTIONS_REQUEST = 'GET_QUESTIONS_REQUEST';
export const GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';

export const ADD_QUESTION_REQUEST = 'ADD_QUESTION_REQUEST';
export const ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS';
